/* eslint-disable @typescript-eslint/no-unused-vars */
import { call, put, takeLatest } from "redux-saga/effects";
import { ApiResponse } from "models";
import { PayloadAction } from "@reduxjs/toolkit";
import couponUsageApi from "api/couponUsage";
import { couponUsageAction } from "./couponUsageSlice";
import { CouponUsagePayload } from "models/couponUsage";

function* getCouponUsage(action: PayloadAction<CouponUsagePayload>) {
  try {
    const response: ApiResponse = yield call(
      couponUsageApi.getCouponUsage,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(couponUsageAction.getCouponUsageSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    yield put(couponUsageAction.getCouponUsageFailed(errorData));
  }
}

export default function* subscriptionSaga() {
  yield takeLatest(couponUsageAction.getCouponUsage, getCouponUsage);
}
